import React, { useState } from "react";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import styles from './DfDonation.module.css';

import DfLogo from '../../assets/imgs/dfLogo.png';
import Banner from '../../assets/imgs/DEENCONNECT-website-for-masjid-promo-responsive.png';
import Buttons from '../Button/Button';
import Image from "next/image";



function DfDonation(props) {



  return (
    <div className="Section">
      <Container maxWidth="lg">
        <div className={styles.DfDonation}>

          <Grid container spacing={3}>

            <Grid item xs={12} sm={6} md={6}>
              <div className={styles.DfDonationInfo}>
                <Image src={DfLogo} />
                <h1>Donate to your favorite not-for-profit organization from anywhere.</h1>

                <Buttons
                  label="Visit DEENFUND"
                  buttonColor="#004FE0"
                  color="#fff"
                  height="48px"
                  fontSize="14px"
                />

              </div>
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <div className={styles.DfDonationImg}>
                <Image src={Banner} />
              </div>
            </Grid>

          </Grid>

        </div>
      </Container>
    </div>
  );
}

export default DfDonation;
